import { getRequest } from '../../httpClient';
import type { IGetPublicCefrV2Response } from './get-public-cefr-v2-response';
import { getPublicCefrV2ResponseSchema } from './get-public-cefr-v2-response';

/**
 * @deprecated No current consumer (web uses `getPublicCefrV1Api`). Frozen, not
 * deleted - an old app binary may still call it. See "Web-only / orphan versions
 * pending deletion" in apps/api/CLAUDE.md.
 */
export async function getPublicCefrV2Api(level: string) {
  return getRequest<IGetPublicCefrV2Response>({
    path: `/challenges/cefr/${encodeURIComponent(level)}/v2`,
    schema: getPublicCefrV2ResponseSchema,
  });
}
